import React, { useState } from 'react';
import CustomTh from '../../../../../../components/table/CustomTh';
import CustomTd from '../../../../../../components/table/CustomTd';
import CustomImageTable from '../../../../../../components/CustomImageTable';
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    errorMsg,
    getDateFormat,
    getTimeFormat
} from '../../../../../../Apis/functions';
import CustomChip from '../../../../../../components/CustomChip';
import TableFunction from '../../../../../../components/table/TableFunction';
import { useDispatch } from 'react-redux';
import {
    CheckIconsOptions,
    IconClockTable, IconCloseChip, IconDeviceAccessTable,
    IconMarkerTable,
    IconScheduleTable
} from '../../../../../../components/buttons/IconButtons';
import { getAccessMethodIcon, getAccessMethodLabel } from '../../../../../../enums/accessMethodEnum';
import { colors } from '../../../../../../enums/colors';
import { POSITION_MODEL } from '../../../../../../Helpers/PositionModel';
import {ACCESS_LOG_GET_DATA} from '../../../../../Dashboard/Contractors/Model/Models';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const AccessLogApp = (
    {
        id, option, accessLogMode
    }
) => {

    const dispatch = useDispatch();
    const [searchResults, setSearchResults] = useState({ content: [], totalElements: 0 });
    const tableId = "tbl_ala_access_log";
    const searchId = "txt_ala_access_log";
    const getDataBuild = ACCESS_LOG_GET_DATA[accessLogMode];

    const getThead = () => {
        return [
            <CustomTh tableId={tableId}>{t('access_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('zone')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('method')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('attempt')}</CustomTh>,
        ];
    };

    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = searchResults?.content.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getDateFormat(item?.entryDate || item?.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </div>
                        <div className={"d-flex"}>
                            <IconClockTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getTimeFormat(item?.entryDate || item?.createdAt)}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <IconMarkerTable className={"mr-8px mb-1"} />
                            {item?.entryZoneName || item?.zoneName || EMPTY_VALUES.DEFAULT}
                        </div>
                        <div className={"d-flex"}>
                            <IconDeviceAccessTable className={"mr-8px mb-1"} />
                            {item?.entryDeviceName || item?.deviceName || EMPTY_VALUES.DEFAULT}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className="d-flex align-items-center justify-content-center">
                            <span className="text-ellipsis icon-hover-secondary-500">
                                <CustomImageTable
                                    isTooltip={true}
                                    tooltip={getAccessMethodLabel(item?.entryAccessMethodId || item?.accessMethodId, t)}
                                    image={getAccessMethodIcon(item?.entryAccessMethodId || item?.accessMethodId)}
                                />
                            </span>
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip legend={ (item?.successfulAttempt || item?.success) ? t('success') : t('denied')}
                            fontColor={(item?.successfulAttempt || item?.success) ? colors.success700 : colors.errorCode700}
                            borderColor={(item?.successfulAttempt || item?.success) ? colors.success150 : colors.errorCode150}
                            background={(item?.successfulAttempt || item?.success) ? colors.success100 : colors.errorCode100}
                            classNameIcon={`${(item?.successfulAttempt || item?.success) ? 'icon-color-success-600' : 'icon-color-error-code-600'} h-16px w-16px`}
                            icon={(item?.successfulAttempt || item?.success) ? CheckIconsOptions : IconCloseChip}
                            iconPosition={POSITION_MODEL.LEFT}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body,
            data: searchResults?.content,
        };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = getDataBuild.buildBody({ page, rowsPerPage, id, option });
        dispatch(getDataBuild.action(body)).then(({ payload: { data: { data, success, code } } }) => {
            if (success === true) setSearchResults(data);
            else errorMsg(code);
        });
    };

    const {
        t,
        thead,
        tbody,
        pagination,
        rowsPerPage
    } = TableFunction({
        data: searchResults,
        getThead,
        getTbody,
        labelRowsPerPage: 'request_per_page',
        hasContainer: true,
        fixedPagination: false,
        getData
    });

    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        pagination
    }

}

export default AccessLogApp;
